import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const FilterToolbar = ({ onFilterChange, onSaveView }) => {
  const [filters, setFilters] = useState({
    search: '',
    dateFrom: '',
    dateTo: '',
    category: '',
    status: '',
    client: '',
    minAmount: '',
    maxAmount: ''
  });

  const [showAdvanced, setShowAdvanced] = useState(false);

  const categoryOptions = [
    { value: '', label: 'Todas as Categorias' },
    { value: 'accommodation', label: 'Hospedagem' },
    { value: 'transport', label: 'Transporte' },
    { value: 'marketing', label: 'Marketing' },
    { value: 'salaries', label: 'Salários' },
    { value: 'taxes', label: 'Impostos' },
    { value: 'office', label: 'Escritório' },
    { value: 'software', label: 'Software' }
  ];

  const statusOptions = [
    { value: '', label: 'Todos os Status' },
    { value: 'pending', label: 'Pendente' },
    { value: 'approved', label: 'Aprovado' },
    { value: 'rejected', label: 'Rejeitado' }
  ];

  const clientOptions = [
    { value: '', label: 'Todos os Clientes' },
    { value: 'client1', label: 'Maria Silva' },
    { value: 'client2', label: 'João Santos' },
    { value: 'client3', label: 'Ana Costa' },
    { value: 'client4', label: 'Pedro Lima' }
  ];

  const savedViews = [
    { value: 'pending-approval', label: 'Pendentes de Aprovação' },
    { value: 'this-month', label: 'Este Mês' },
    { value: 'high-value', label: 'Alto Valor (&gt; R$ 5.000)' },
    { value: 'no-receipt', label: 'Sem Comprovante' }
  ];

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const handleClearFilters = () => {
    const clearedFilters = {
      search: '',
      dateFrom: '',
      dateTo: '',
      category: '',
      status: '',
      client: '',
      minAmount: '',
      maxAmount: ''
    };
    setFilters(clearedFilters);
    onFilterChange(clearedFilters);
  };

  const handleLoadView = (viewId) => {
    console.log('Loading saved view:', viewId);
  };

  return (
    <div className="bg-card border-b border-border">
      <div className="p-4 space-y-4">
        <div className="flex items-center gap-3">
          <div className="flex-1">
            <Input
              type="search"
              placeholder="Buscar por fornecedor, descrição ou valor..."
              value={filters?.search}
              onChange={(e) => handleFilterChange('search', e?.target?.value)}
            />
          </div>
          <Button
            variant="outline"
            iconName={showAdvanced ? 'ChevronUp' : 'ChevronDown'}
            onClick={() => setShowAdvanced(!showAdvanced)}
          >
            Filtros Avançados
          </Button>
          <Button variant="outline" iconName="Save" onClick={onSaveView}>
            Salvar Visualização
          </Button>
        </div>

        <div className="flex items-center gap-3 flex-wrap">
          <Select
            options={savedViews}
            value=""
            onChange={handleLoadView}
            placeholder="Visualizações Salvas"
            className="w-64"
          />

          <Select
            options={categoryOptions}
            value={filters?.category}
            onChange={(value) => handleFilterChange('category', value)}
            className="w-48"
          />

          <Select
            options={statusOptions}
            value={filters?.status}
            onChange={(value) => handleFilterChange('status', value)}
            className="w-48"
          />

          <Select
            options={clientOptions}
            value={filters?.client}
            onChange={(value) => handleFilterChange('client', value)}
            className="w-48"
          />

          {(filters?.search || filters?.category || filters?.status || filters?.client) && (
            <Button variant="ghost" size="sm" iconName="X" onClick={handleClearFilters}>
              Limpar Filtros
            </Button>
          )}
        </div>

        {showAdvanced && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 p-4 bg-muted/50 rounded-lg">
            <Input
              label="Data Inicial"
              type="date"
              value={filters?.dateFrom}
              onChange={(e) => handleFilterChange('dateFrom', e?.target?.value)}
            />

            <Input
              label="Data Final"
              type="date"
              value={filters?.dateTo}
              onChange={(e) => handleFilterChange('dateTo', e?.target?.value)}
            />

            <Input
              label="Valor Mínimo"
              type="number"
              placeholder="0,00"
              value={filters?.minAmount}
              onChange={(e) => handleFilterChange('minAmount', e?.target?.value)}
            />

            <Input
              label="Valor Máximo"
              type="number"
              placeholder="0,00"
              value={filters?.maxAmount}
              onChange={(e) => handleFilterChange('maxAmount', e?.target?.value)}
            />
          </div>
        )}
      </div>
      <div className="px-4 pb-4 flex items-center gap-4">
        <div className="flex items-center gap-2">
          <Icon name="Info" size={16} className="text-muted-foreground" />
          <span className="text-sm text-muted-foreground">
            Atalhos: Ctrl+F (Buscar), Ctrl+N (Nova Despesa), Ctrl+E (Exportar)
          </span>
        </div>
      </div>
    </div>
  );
};

export default FilterToolbar;